import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Covert Church Crunch',
  date: new Date(2023, 5, 25),
  img: '/img/mimosa.jpeg',
  tracks: [
    {
      title: 'Breakfast Burrito',
      src: '/songs/2023-06-25/breakfast_burrito.mp3',
    },
    {
      title: 'Veggie Scramble',
      src: '/songs/2023-06-25/veggie_scramble.mp3',
    },
    {
      title: 'Fresh Pot of Coffee',
      src: '/songs/2023-06-25/fresh_pot_of_coffee.mp3',
    },
    {
      title: 'Retirement Brunch',
      src: '/songs/2023-06-25/retirement_brunch.mp3',
    },
    {
      title: 'Mimosa',
      src: '/songs/2023-06-25/mimosa.mp3',
    },
    {
      title: 'Biscuits and Gravy',
      src: '/songs/2023-06-25/biscuits_and_gravy.mp3',
    },
    {
      title: 'Sunday Jam with a Side of The Man',
      src: '/songs/2023-06-25/sunday_jam.mp3',
    },
    {
      title: 'Dine and Dash',
      src: '/songs/2023-06-25/dine_and_dash.mp3',
    },
    {
      title: 'Philly Cheese Steak with Extra Bass',
      src: '/songs/2023-06-25/philly_cheese_steak.mp3',
    },
    {
      title: 'Early Bird Dinner Special',
      src: '/songs/2023-06-25/early_bird_dinner_special.mp3',
    },
    {
      title: 'Appetizers',
      src: '/songs/2023-06-25/appetizers.mp3',
    },
    {
      title: 'Feeding Frenzy',
      src: '/songs/2023-06-25/feeding_frenzy.mp3',
    },
    {
      title: 'Absinthe Apperitiff',
      src: '/songs/2023-06-25/absinthe_apperitif.mp3',
    },
    {
      title: 'Bacon Jam Dessert',
      src: '/songs/2023-06-25/bacon_jam_dessert.mp3',
    },
  ]
}
export default album;